export default __webpack_public_path__ + "static/media/next-icon.01ac8d79.svg";